<div id="no_access" *ngIf="proVersion == 'false'">
  <div class="no_access_image">
    <img src="assets/image/pomodoro-illustration.svg" alt="No Access">
  </div>
  <div class="no_access_title">
    برای استفاده از این قابلیت، باید حساب کاربری خود را ارتقاء دهید!
  </div>
  <div class="no_access_cta">
    <a style="cursor: pointer" [routerLink]="['/pricing']">ارتقاء حساب کاربری</a>
  </div>
</div>
<div id="main_app" class="container-fluid" *ngIf="proVersion == 'true'">
  <div class="container">
    <div class="ranking_title">یادآوری پیامکی</div>
    <div class="ranking_excerpt">تا ۲۰ پیامک یادآوری در ماه، بصورت اتوماتیک برای خود تنظیم کنید!</div>
    <div class="reminder_box">
      <form action="">
        <div class="col_reminder">
            <input class="date-selector" #fromInput matInput [matDatepicker]="picker5" [min]="time" (dateInput)="onInput($event)" (dateChange)="onChange($event)"
                   placeholder="انتخاب زمان">
            <mat-datepicker-toggle class="date-toggle" matSuffix [for]="picker5"></mat-datepicker-toggle>
            <mat-datepicker #picker5></mat-datepicker>
        </div>
        <div class="col_reminder">
          <input class="date-selector" placeholder="انتخاب زمان" (click)="switchShowTimer()" name="data" [(ngModel)]="pomodoroRepository.dateData">
          <button class="time-toggle" (click)="switchShowTimer()">
            <mat-icon aria-hidden="false" aria-label="Example alarm icon">access_time</mat-icon>
          </button>
          <ng-container *ngIf="pomodoroRepository.showTimer">
            <app-time-selector></app-time-selector>
          </ng-container>
        </div>
        <div class="row_reminder">
          <textarea name="text" maxlength="70" placeholder="متن پیام یادآوری... (۷۰ کاراکتر)" [(ngModel)]="reminder.text" (change)="setText(reminder.text)"></textarea>
        </div>
        <div class="row_reminder">
          <button (click)="setReminder()">تنظیم یادآوری</button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div><!-- .reminder_box -->
    <ng-container *ngFor="let reminder of reminders">
      <div [ngClass]="{'sent': reminder.is_send, 'd_none': reminder.archive}">
        <div class="reminder_message" *ngIf="!reminder.is_send">
          <div class="reminder_date_and_time" *ngIf="!reminder.is_edit">
            {{reminder.jalali_send_date}}
          </div>
          <div class="reminder_date_and_time" *ngIf="reminder.is_edit">
            {{reminder.jalali_send_date}}
          </div>
          <div class="flex-f">
            <div class="reminder_message_content" *ngIf="!reminder.is_edit">
              {{reminder.content}}
            </div>
            <div class="reminder_message_content" *ngIf="reminder.is_edit">
              <input type="text" class="reminder_input" [@fadeInOnEnter] [@fadeOutOnLeave] [(ngModel)]="editContent" (keyup.enter)="updateReminder(reminder)">
            </div>
            <div class="btn-group">
              <button class="btn delete p-0" (click)="deleteReminder(reminder.id)">
                <mat-icon class="reminder-icons" aria-hidden="false" aria-label="Example delete icon">delete</mat-icon>
              </button>
              <button class="btn edit p-0" (click)="showEditMode(reminder)">
                <mat-icon class="reminder-icons" aria-hidden="false" aria-label="Example edit icon">edit</mat-icon>
              </button>
            </div>
          </div>
        </div><!-- .reminder_message -->
        <div class="reminder_message" *ngIf="reminder.is_send">
          <div class="reminder_date_and_time">
            {{reminder.jalali_send_date}}
          </div>
          <div class="flex-f">
            <div class="reminder_message_content">
              {{reminder.content}}
            </div>
            <div class="btn-group">
                <button class="btn edit p-0" (click)="archiveReminder(reminder)">
                  <mat-icon style="margin-right: 24px" class="reminder-icons" aria-hidden="false" aria-label="Example archive icon">
                    archive
                  </mat-icon>
                </button>
            </div>
          </div>
        </div><!-- .reminder_message -->
      </div>
    </ng-container>
    <div class="row_reminder archives">
      <button (click)="navigateToArchive()">پیامک های آرشیو شده</button>
    </div>
    <div class="clearfix"></div>
  </div><!-- .container -->
</div><!-- #main_app -->
<app-footer></app-footer>
